import Vue from "vue";
import { ActionContext, ActionTree } from "vuex";
import { RootState } from "@/store/modules/general/types";
import { AxiosResponse } from "axios";
import { FACTURA, FECHAS } from "./types";

type FacturasContext = ActionContext<FACTURA, RootState>;
type FacturasActionTree = ActionTree<FACTURA, RootState>;

export const actions: FacturasActionTree = {
  async listarFacturas(context: FacturasContext, payload: any): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Facturas/ListarFacturas",
        params: payload,
      });
      return response.data;
    } catch (error) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },
  async GetPdf(context: FacturasContext, payload: any): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Facturas/GetPdfFactura",
        params: payload,
      });
      return response.data;
    } catch (error) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },
  async loadConfig(context: FacturasContext, payload: any): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Facturas/LoadConfig",
        params: payload,
      });
      return response.data;
    } catch (error) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },
};
